export interface TeamMember {
  id: string;
  name: string;
  role: string;
  description: string;
  avatar: string;
}

export const leadership: TeamMember[] = [
  {
    id: "naamdeo",
    name: "Mr Naamdeo",
    role: "Chairman",
    description:
      "A true visionary and ambassador of global change, Mr. Naam Deo is a social entrepreneur who leads by example, championing the principles which inform our philosophy as an organisation. With his vision, Sadafal Education was launched in 2010.",
    avatar:
      "https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/bcfafe48-c956-46d2-3e2e-78c661811d00/public",
  },
  {
    id: "robin",
    name: "Mr Robin Rajan",
    role: "Director of Projects",
    description:
      "Robin is a hospitality industry leader, educator, and social entrepreneur with 40+ years' experience, blending industry expertise with philanthropy to empower underprivileged communities through vocational education, training, and impactful initiatives across Australia and India.",
    avatar: "/team-robin.png",
  },
  {
    id: "shekher",
    name: "Mr Shekher Kishore",
    role: "Director of Education",
    description:
      "With over 30 years in managing vocational education and training institutions across Australia, Shekher guides our educational initiatives in India and Kenya with deep expertise in quality frameworks.",
    avatar: "/team/shekher.jpg",
  },
  {
    id: "reeta",
    name: "Mrs Reeta Shrivastava",
    role: "Project Manager",
    description:
      "With over thirty-five years of education experience focused on early childhood and primary education, Reeta leads the Sadafal Education Skills Centre in Keshripur village from the front.",
    avatar: "/team/reeta.jpg",
  },
  {
    id: "chetan",
    name: "Mr Chetan Srivastav",
    role: "Trustee",
    description:
      "A quality, environmental, and safety management professional with over three decades of experience, Chetan is Managing Director & CEO of Management System Integritas. As a Trustee, he works to help youth and underprivileged communities become self-reliant through practical education and vocational training.",
    avatar: "/team/chetan.jpg",
  },
];
